// components/OrderMenu.jsx
import React from 'react';
import { NavLink } from 'react-router-dom';
import ADMIN_PATHS from '../../ADMIN_PATHS';
import { List, Info, Plus, Truck, AlertTriangle, Undo, History } from 'lucide-react';

const menuItems = [
  { path: ADMIN_PATHS.ORDERS_PAGES.ALL, label: 'All Orders', icon: List },
  { path: ADMIN_PATHS.ORDERS_PAGES.DETAILS, label: 'Order Details', icon: Info },
  { path: ADMIN_PATHS.ORDERS_PAGES.MANUAL, label: 'Manual Order', icon: Plus },
  { path: ADMIN_PATHS.ORDERS_PAGES.ALIEXPRESS, label: 'AliExpress Forwarding', icon: Truck },
  { path: ADMIN_PATHS.ORDERS_PAGES.RECOVERY, label: 'Failed/Cancelled', icon: AlertTriangle },
  { path: ADMIN_PATHS.ORDERS_PAGES.REFUNDS, label: 'Refunds', icon: Undo },
  { path: ADMIN_PATHS.ORDERS_PAGES.STATUS_LOGS, label: 'Status Logs', icon: History },
];

const OrderMenu = () => {
  return (
    <header className="sticky top-0 z-40 border-b border-slate-200 bg-white/85 backdrop-blur">
      <div className="mx-auto px-4 md:px-6 py-3">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-2 min-w-0">
            <span className="h-4 w-[3px] rounded-full bg-primary" aria-hidden="true" />
            <h1 className="text-base md:text-lg font-black tracking-tight text-slate-900 truncate">
              Order Management
            </h1>
          </div>

          <div className="hidden md:flex items-center gap-2 text-xs text-slate-500">
            <List size={14} className="text-primary" />
            <span>Manage, review, and resolve orders</span>
          </div>
        </div>

        {/* Tabs removed per request */}
      </div>
    </header>
  );
};

export default OrderMenu;
